/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import FormSection from '@/components/forms/FormSection'
import InputText from '@/components/forms/InputText'
import { useResponsive } from '@/hooks/useResponsive'
import { Flex, useBreakpointValue } from '@chakra-ui/react'
import React from 'react'

const FlexWrapper = ({ children, className = '', flexDirection }) => (
  <Flex
    className={className}
    flexDirection={flexDirection}
  >
    { children }
  </Flex>
)

const BuildLicenseListingTermsForm = ({
  register,
  errors
}) => {
  const { flexDirection } = useResponsive()
  const widthClass = useBreakpointValue({
    md: 'w-[700px]'
  })
  return (
    <FormSection
      title="Build License Listing Terms"
      className={widthClass}
    >
      <FlexWrapper
        className="gap-4"
        flexDirection={flexDirection}
      >
        <InputText
          errorMessage={errors?.minimumPrice?.message}
          label="Minimum Price ($)"
          { ...register('minimumPrice') }
        />
        <InputText
          errorMessage={errors?.requiredRoyalty?.message}
          label="Required Royalty (%)"
          rightAddonContent="%"
          { ...register('requiredRoyalty') }
        />
        <InputText
          errorMessage={errors?.numberLicenses?.message}
          label="Number of Licenses"
          { ...register('numberLicenses') }
        />
      </FlexWrapper>
      <FlexWrapper className="gap-3" flexDirection={flexDirection}>
        <InputText
          errorMessage={errors?.usageLimit?.message}
          label="Usage Limit"
          { ...register('usageLimit') }
        />
        <InputText
          errorMessage={errors?.usageFee?.message}
          label="Usage Fee"
          { ...register('usageFee') }
        />
        <InputText
          errorMessage={errors?.licenseTerm?.message}
          label="LicenseTerm (days)"
          { ...register('licenseTerm') }
        />
      </FlexWrapper>
    </FormSection>
  )
}

export default BuildLicenseListingTermsForm
